const VISIBILITY_PUBLIC = 'public';
const VISIBILITY_FOR_CASHIER = 'for_cashier';
const VISIBILITY_TECHNICAL = 'technical';
const VISIBILITY_DISABLED = 'disabled';
const MAX_TICKETS_PER_BUYER = 20;
const ROOT_FIELD_NAME = 'ticket_types';

export {
    VISIBILITY_PUBLIC,
    VISIBILITY_FOR_CASHIER,
    VISIBILITY_DISABLED,
    MAX_TICKETS_PER_BUYER,
    ROOT_FIELD_NAME,
    VISIBILITY_TECHNICAL,
};
